module.exports = __webpack_public_path__ + "img/mianduimian.b512b892.png";